export const standardLabels = [
  {
    color: "#3d8cf6",
    borderColor: "#0070f5",
  },
  {
    color: "#f7ce33",
    borderColor: "#f5c200",
  },
  {
    color: "#f75951",
    borderColor: "#f53126",
  },
  {
    color: "#4bcf5f",
    borderColor: "#1ec338",
  },
  {
    color: "#f8a133",
    borderColor: "#f58c01",
  },
  {
    color: "#b270d3",
    borderColor: "#9f4bc9",
  },
  {
    color: "#52cddd",
    borderColor: "#43bac9",
  },
  {
    color: "#6c71f7",
    borderColor: "#565bd9",
  },
  {
    color: "#748898",
    borderColor: "#5a7284",
  },
  {
    color: "#f63daf",
    borderColor: "#f500aa",
  },
];
